// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// TODO: https://jira.tamg.io/browse/WP-2462
import * as React from 'react';
import { connect } from 'react-redux';
import SlideInModal from '@ta/modal.slide-in';
import { Opener, Closer, Global } from '@ta/overlays.managers';

type ExternalProps = {|
  /** Globally unique name for this overlay. You'll then be able to open the overlay by name. */
  name: string,

  /** Direction from which to slide in from */
  slideFrom: 'left' | 'right' | 'top' | 'bottom',

  /** Optional header content. You typically want the TitleBar component. */
  header?: React.Node,

  /** Optional footer content */
  footer?: React.Node,

  /** Optional handler for overlay dismiss */
  onClose?: () => mixed,

  /** Don't show the closer X */
  hideX?: boolean,

  closeXColorVariant?: 'TA_GREEN' | 'TA_GREEN_DARK' | 'WHITE' | 'SEAT_GURU_BLUE',

  /** The render prop. Passes the callback for close and the state of the overlay. */
  children: (close: () => void, shouldShow: boolean) => React.Node,

  /** Class name to apply to the body content */
  bodyContentClass?: string,

  /** Optional time for the transition, in milliseconds */
  transitionDuration?: number,

  /** Optional flag on whether to not show the backdrop */
  noBackdrop?: boolean,

  /** ClassName that wraps header, children, footer, and close icon of the SlideInModal */
  wrapperClass?: string,
|};

type Props = {|
  ...ExternalProps,

  /** If we are on an RTL page then the we need to reverse the slide in transition */
  isRtl: boolean,
|};

const TRANSITION_DURATION = 250; // ms

/**
 * An overlay that slides in from a given direction. Typically used for a responsive side rail or a drawer.
 * @deprecated  Use @ta/modal.slide-in instead
 */
const SlideInOverlay = ({
  name,
  onClose,
  children,
  slideFrom,
  header,
  footer,
  hideX,
  closeXColorVariant,
  bodyContentClass,
  transitionDuration,
  noBackdrop,
  wrapperClass,
}: Props) => (
  <Opener name={name}>
    {(open, isOpen) => (
      <Closer>
        {close => {
          const closer = () => {
            close();
            if (onClose) {
              onClose();
            }
          };

          return (
            <Global name={name} transitionDuration={TRANSITION_DURATION}>
              <SlideInModal
                slideFrom={slideFrom}
                isOpen={isOpen}
                header={header}
                footer={footer}
                onClose={closer}
                enableCloseIcon={!hideX}
                closeIconColorVariant={closeXColorVariant}
                bodyContentClass={bodyContentClass}
                transitionDuration={transitionDuration}
                hideBackdrop={noBackdrop}
                wrapperClass={wrapperClass}
                disableAutoFocus
                enableEventBoundary
              >
                {children(closer, isOpen)}
              </SlideInModal>
            </Global>
          );
        }}
      </Closer>
    )}
  </Opener>
);

SlideInOverlay.defaultProps = {
  isRtl: false,
  header: null,
  footer: null,
  onClose: undefined,
  hideX: false,
  bodyContentClass: '',
  transitionDuration: TRANSITION_DURATION,
  noBackdrop: false,
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  isRtl: state.i18n.isRtl,
}))(SlideInOverlay);
